import { render, staticRenderFns } from "./unreceiveTips.vue?vue&type=template&id=c92498e2&scoped=true&"
import script from "./unreceiveTips.vue?vue&type=script&lang=js&"
export * from "./unreceiveTips.vue?vue&type=script&lang=js&"
import style0 from "./unreceiveTips.vue?vue&type=style&index=0&id=c92498e2&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92498e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92498e2')) {
      api.createRecord('c92498e2', component.options)
    } else {
      api.reload('c92498e2', component.options)
    }
    module.hot.accept("./unreceiveTips.vue?vue&type=template&id=c92498e2&scoped=true&", function () {
      api.rerender('c92498e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/tokenList/unreceiveTips.vue"
export default component.exports